import { render, staticRenderFns } from "./widget_portfolio_index.vue?vue&type=template&id=098785e6&scoped=true&"
import script from "./widget_portfolio_index.vue?vue&type=script&lang=js&"
export * from "./widget_portfolio_index.vue?vue&type=script&lang=js&"
import style0 from "./widget_portfolio_index.vue?vue&type=style&index=0&id=098785e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098785e6",
  null
  
)

export default component.exports